import { render, staticRenderFns } from "./list-assinatura.vue?vue&type=template&id=cc5e32d0&scoped=true"
import script from "./list-assinatura.vue?vue&type=script&lang=js"
export * from "./list-assinatura.vue?vue&type=script&lang=js"
import style0 from "./list-assinatura.vue?vue&type=style&index=0&id=cc5e32d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5e32d0",
  null
  
)

export default component.exports